import React from 'react'
import '../styles/css/ContentHeader.css'

const ContentHeader = ({ title, buttonTitle, buttonClass, buttonClick, children }) => (
    <div id="content-header">
        <div id="col">
            <h1>{title}</h1>
        </div>
        <div id="col">
            {buttonTitle && <button onClick={buttonClick} className={buttonClass}>{buttonTitle}</button>}
            {children && children}
        </div>
    </div>
)

export default ContentHeader


// WEBPACK FOOTER //
// ./src/components/ContentHeader.js